import React from 'react'
import styles from './Authorization.module.scss'
import LanguageSwitch from '@/components/LanguageSwitch/LanguageSwitch'

type AuthorizationProps = {
  children: React.ReactNode
}

function Authorization(props: AuthorizationProps) {
  const { children } = props
  return (
    <div className={`${styles.authorizationFormContainer}`}>
      <div className={`${styles.authorizationHeader}`}>
        <div id="logo" className={`${styles.logo}`} />
        <LanguageSwitch />
      </div>
      {children}
    </div>
  )
}

export default Authorization
